(function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESKTOP_MQ = window.matchMedia('(min-width: 750px)');
  var LOOP_LAPS = 2;

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  function initHomeCarousel(root, options) {
    if (!root) return;

    var track = root.querySelector(options.track);
    var prog = root.querySelector(options.progress);
    var prev = root.querySelector(options.prev);
    var next = root.querySelector(options.next);
    if (!track) return;

    if (track._homeCarouselTeardown) track._homeCarouselTeardown();

    var cardSelector = options.card;
    var infiniteWanted = root.getAttribute('data-carousel-infinite') !== 'false';

    var settleTimer;
    var finishTimer;
    var scrollRaf;

    function allSlides() {
      return toArray(track.querySelectorAll(cardSelector));
    }

    function realSlides() {
      return allSlides().filter(function (card) {
        return !card.hasAttribute('data-carousel-clone');
      });
    }

    function slideTotal() {
      var stored = parseInt(track.dataset.slideCount, 10);
      return stored > 0 ? stored : realSlides().length;
    }

    function loopEnabled() {
      return track.dataset.loopEnabled === 'true';
    }

    function carouselGap() {
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap);
      if (isNaN(gap)) gap = parseFloat(styles.gap);
      return isNaN(gap) ? 0 : gap;
    }

    function maxScrollLeft() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function realOverflow() {
      var reals = realSlides();
      if (!reals.length) return false;
      var stride = reals[0].offsetWidth + carouselGap();
      return stride * reals.length - carouselGap() > track.clientWidth + 2;
    }

    function shouldLoop() {
      return infiniteWanted && DESKTOP_MQ.matches && realSlides().length > 1 && realOverflow();
    }

    function slidesPerView() {
      var reals = realSlides();
      if (!reals.length) return 1;
      var stride = reals[0].offsetWidth + carouselGap();
      if (stride <= 0) return 1;
      return Math.max(1, Math.min(reals.length, Math.floor((track.clientWidth + carouselGap()) / stride)));
    }

    function realStartIndex() {
      return slideTotal() * LOOP_LAPS;
    }

    function slideScrollLeft(slide) {
      return slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }

    function nearestSlideIndex(items) {
      items = items || allSlides();
      if (!items.length) return 0;
      var current = track.scrollLeft;
      var index = 0;
      var best = Infinity;
      items.forEach(function (slide, i) {
        var dist = Math.abs(slideScrollLeft(slide) - current);
        if (dist < best) {
          best = dist;
          index = i;
        }
      });
      return index;
    }

    function logicalIndex() {
      var count = slideTotal();
      if (count <= 0) return 0;
      var items = allSlides();
      var index = nearestSlideIndex(items);
      if (!loopEnabled()) return Math.min(index, count - 1);
      var start = realStartIndex();
      return ((index - start) % count + count) % count;
    }

    function realSlideForLogical(logical, items) {
      items = items || allSlides();
      var count = slideTotal();
      if (!count) return null;
      var normalized = ((logical % count) + count) % count;
      return items[realStartIndex() + normalized] || null;
    }

    function makeClone(card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('data-carousel-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('id');
      clone.removeAttribute('data-reveal');
      toArray(clone.attributes).forEach(function (attr) {
        if (/-init$/.test(attr.name) || attr.name.indexOf('data-shopify') === 0) {
          clone.removeAttribute(attr.name);
        }
      });
      clone.classList.add('is-visible');
      clone.querySelectorAll('[id]').forEach(function (el) {
        el.removeAttribute('id');
      });
      clone.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.removeAttribute('data-reveal');
        el.classList.add('is-visible');
      });
      clone.querySelectorAll('img').forEach(function (img) {
        img.loading = 'eager';
        img.removeAttribute('data-reveal');
      });
      return clone;
    }

    function instantScroll(left) {
      var prevSnap = track.style.scrollSnapType;
      var prevBehavior = track.style.scrollBehavior;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = Math.round(Math.max(0, Math.min(left, maxScrollLeft())));
      track.style.scrollBehavior = prevBehavior;
      track.style.scrollSnapType = prevSnap;
    }

    function inRealZone(items) {
      items = items || allSlides();
      var start = realStartIndex();
      var index = nearestSlideIndex(items);
      return index >= start && index < start + slideTotal();
    }

    // Silently shift a settled clone position back onto the matching real slide.
    function recenter() {
      if (!loopEnabled() || track.dataset.recentering === 'true') return false;
      var items = allSlides();
      var count = slideTotal();
      if (items.length <= count || inRealZone(items)) return false;

      var start = realStartIndex();
      var index = nearestSlideIndex(items);
      var logical = ((index - start) % count + count) % count;
      var target = items[start + logical];
      var current = items[index];
      if (!target || !current) return false;

      var nextLeft = track.scrollLeft + slideScrollLeft(target) - slideScrollLeft(current);
      if (Math.abs(nextLeft - track.scrollLeft) <= 2) return false;

      track.dataset.recentering = 'true';
      instantScroll(nextLeft);
      delete track.dataset.recentering;
      return true;
    }

    function clearTimers() {
      window.clearTimeout(settleTimer);
      window.clearTimeout(finishTimer);
    }

    function finishMotion() {
      clearTimers();
      delete track.dataset.animating;
      recenter();
      sync();
    }

    function scheduleSettle() {
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(finishMotion, 120);
    }

    function scrollToPosition(left) {
      var target = Math.max(0, Math.min(left, maxScrollLeft()));
      if (Math.abs(track.scrollLeft - target) <= 2) {
        finishMotion();
        return;
      }
      if (prefersReduced) {
        clearTimers();
        instantScroll(target);
        finishMotion();
        return;
      }
      track.dataset.animating = 'true';
      clearTimers();
      track.scrollTo({ left: target, behavior: 'smooth' });
      finishTimer = window.setTimeout(finishMotion, 500);
      scheduleSettle();
    }

    function scrollToIndex(index) {
      var items = allSlides();
      var count = slideTotal();
      if (!items.length || count <= 0) return;
      var targetIndex = loopEnabled()
        ? Math.max(0, Math.min(index, items.length - 1))
        : Math.max(0, Math.min(index, count - 1));
      scrollToPosition(slideScrollLeft(items[targetIndex]));
    }

    function scrollByStep(direction) {
      var items = allSlides();
      var count = slideTotal();
      if (!items.length || count <= 0) return;
      if (loopEnabled()) {
        recenter();
        scrollToIndex(nearestSlideIndex(items) + direction);
        return;
      }
      scrollToIndex(logicalIndex() + direction);
    }

    function renderProgress(index) {
      if (!prog) return;
      var total = slideTotal();
      if (total <= 1) {
        prog.style.width = '100%';
        prog.style.left = '0';
        prog.style.transform = 'none';
        return;
      }
      var segment = 100 / total;
      var travel = 100 - segment;
      prog.style.width = segment + '%';
      prog.style.left = (index / (total - 1)) * travel + '%';
      prog.style.transform = 'none';
    }

    function updateButtons() {
      if (loopEnabled()) {
        if (prev) prev.disabled = false;
        if (next) next.disabled = false;
        return;
      }
      var count = slideTotal();
      var spv = slidesPerView();
      var index = logicalIndex();
      var max = maxScrollLeft();
      var left = track.scrollLeft;
      var atEnd = count <= spv || index >= count - spv || max <= 2 || left >= max - 2;
      var atStart = index <= 0 && left <= 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }

    function sync() {
      renderProgress(logicalIndex());
      updateButtons();
    }

    function removeClones() {
      track.querySelectorAll('[data-carousel-clone]').forEach(function (el) {
        el.parentNode.removeChild(el);
      });
    }

    // Returns true when the clone set was rebuilt (so scroll must be repositioned).
    function setupLoop() {
      var originals = realSlides();
      var count = originals.length;
      var wantLoop = count > 1 && shouldLoop();
      var expectedClones = wantLoop ? count * LOOP_LAPS * 2 : 0;
      var existingClones = track.querySelectorAll('[data-carousel-clone]').length;

      if (
        wantLoop &&
        loopEnabled() &&
        track.dataset.slideCount === String(count) &&
        existingClones === expectedClones
      ) {
        return false;
      }

      var savedLogical = loopEnabled() ? logicalIndex() : 0;
      removeClones();
      delete track.dataset.loopEnabled;
      track.dataset.slideCount = String(count);
      if (!wantLoop) return true;

      track.dataset.loopEnabled = 'true';

      var first = originals[0];
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      var lap;
      for (lap = 0; lap < LOOP_LAPS; lap += 1) {
        originals.forEach(function (card) {
          before.appendChild(makeClone(card));
        });
      }
      for (lap = 0; lap < LOOP_LAPS; lap += 1) {
        originals.forEach(function (card) {
          after.appendChild(makeClone(card));
        });
      }
      track.insertBefore(before, first);
      track.appendChild(after);

      var items = allSlides();
      var logical = ((savedLogical % count) + count) % count;
      var target = items[realStartIndex() + logical];
      if (target) instantScroll(slideScrollLeft(target));
      return true;
    }

    function refresh() {
      setupLoop();
      sync();
    }

    var onPrevClick = function () {
      scrollByStep(-1);
    };
    var onNextClick = function () {
      scrollByStep(1);
    };

    var onScroll = function () {
      if (!scrollRaf) {
        scrollRaf = window.requestAnimationFrame(function () {
          scrollRaf = 0;
          sync();
        });
      }
      if (track.classList.contains('is-dragging')) return;
      if (track.dataset.animating !== 'true') scheduleSettle();
    };

    var onScrollEnd = function () {
      finishMotion();
    };

    if (prev) prev.addEventListener('click', onPrevClick);
    if (next) next.addEventListener('click', onNextClick);
    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('scrollend', onScrollEnd, { passive: true });

    // Desktop click-drag with snap to the nearest slide on release.
    var pointerActive = false;
    var dragging = false;
    var pointerId = null;
    var startX = 0;
    var startScroll = 0;
    var DRAG_THRESHOLD = 8;
    var INTERACTIVE = 'a, button, input, label, select, textarea, summary, [role="button"]';

    var onPointerMove = function (event) {
      if (!pointerActive || event.pointerId !== pointerId) return;
      var delta = event.pageX - startX;
      if (!dragging) {
        if (Math.abs(delta) <= DRAG_THRESHOLD) return;
        dragging = true;
        track.classList.add('is-dragging');
        if (track.setPointerCapture) track.setPointerCapture(pointerId);
      }
      event.preventDefault();
      track.scrollLeft = startScroll - delta;
      sync();
    };

    var endPointer = function (event) {
      if (!pointerActive) return;
      if (event && event.pointerId != null && event.pointerId !== pointerId) return;
      var wasDragging = dragging;
      pointerActive = false;
      dragging = false;
      var releasedId = pointerId;
      pointerId = null;
      track.classList.remove('is-dragging');
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', endPointer);
      document.removeEventListener('pointercancel', endPointer);
      if (wasDragging) {
        if (track.releasePointerCapture && releasedId != null) {
          try { track.releasePointerCapture(releasedId); } catch (e) {}
        }
        scrollToIndex(nearestSlideIndex(allSlides()));
        track.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopPropagation();
          },
          { capture: true, once: true }
        );
      }
    };

    var onPointerDown = function (event) {
      if (!DESKTOP_MQ.matches) return;
      if (event.button !== 0) return;
      if (event.target.closest && event.target.closest(INTERACTIVE)) return;
      clearTimers();
      delete track.dataset.animating;
      pointerActive = true;
      dragging = false;
      pointerId = event.pointerId;
      startX = event.pageX;
      startScroll = track.scrollLeft;
      document.addEventListener('pointermove', onPointerMove);
      document.addEventListener('pointerup', endPointer);
      document.addEventListener('pointercancel', endPointer);
    };

    var onDragStart = function (e) {
      e.preventDefault();
    };

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('dragstart', onDragStart);

    var onMqChange = function () {
      track.classList.remove('is-dragging');
      refresh();
    };
    DESKTOP_MQ.addEventListener('change', onMqChange);

    var ro;
    var resizeTimer;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(refresh, 150);
      });
      ro.observe(track);
    }

    var onLoad = function () {
      refresh();
    };
    window.addEventListener('load', onLoad);

    track._homeCarouselTeardown = function () {
      if (prev) prev.removeEventListener('click', onPrevClick);
      if (next) next.removeEventListener('click', onNextClick);
      track.removeEventListener('scroll', onScroll);
      track.removeEventListener('scrollend', onScrollEnd);
      track.removeEventListener('pointerdown', onPointerDown);
      track.removeEventListener('dragstart', onDragStart);
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', endPointer);
      document.removeEventListener('pointercancel', endPointer);
      DESKTOP_MQ.removeEventListener('change', onMqChange);
      window.removeEventListener('load', onLoad);
      clearTimers();
      if (ro) ro.disconnect();
      removeClones();
      delete track.dataset.slideCount;
      delete track.dataset.loopEnabled;
      delete track.dataset.recentering;
      delete track.dataset.animating;
      track.classList.remove('is-dragging');
      delete track._homeCarouselTeardown;
    };

    refresh();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(refresh);
    });
  }

  function bootOne(root) {
    initHomeCarousel(root, {
      track: root.getAttribute('data-carousel-track'),
      card: root.getAttribute('data-carousel-card'),
      progress: root.getAttribute('data-carousel-progress'),
      prev: root.getAttribute('data-carousel-prev'),
      next: root.getAttribute('data-carousel-next')
    });
  }

  function bootAll(scope) {
    (scope || document).querySelectorAll('[data-home-carousel]').forEach(bootOne);
  }

  window.initHomeCarousel = initHomeCarousel;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootAll();
    });
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    bootAll(e.target);
  });
})();
